import statusTypes from './status-types'

const echopeClassificationEnum = {
  E1: 'E1',
  E2: 'E2',
  E3: 'E3',
  E4: 'E4',
  E5: 'E5',
}

const onlinePaymentModelEnum = {
  PAY_ON_PICKUP: 'PayOnPickup',
  PAY_ONLINE: 'PayOnline',
}

const coldOptionEnum = {
  COLD_ON_ICE: 'ColdOnIce',
  COLD: 'Cold',
  NATURAL: 'Natural',
}

const saleReasonEnum = {
  SALE: 'Sale',
  STOCK_TRANSFER: 'StockTransfer',
  STOCK_LOSSES: 'StockLosses',
  STORE_LENDING: 'StoreLending',
  PRODUCT_BONUS: 'ProductBonus',
  CHOPP_GIFT_CARD_CONVERSION: 'ChoppGiftCardConversion',
}

const unitValueTypeEnum = {
  PRICE_TABLE: 'PriceTable',
  MANUAL_INCREASE: 'ManualIncrease',
  TIERED_PRICE: 'TieredPrice',
  PROMOTION: '  Promotion',
}

const pickupPointEnum = {
  COUNTER: 'Counter',
  DRIVE_THRU: 'DriveThru',
}

const saleDomain = {
  data() {
    return {
      echopeClassificationEnum,
      onlinePaymentModelEnum,
      coldOptionEnum,
      saleReasonEnum,
      unitValueTypeEnum,
      pickupPointEnum,
    }
  },

  computed: {
    saleOriginEnum() {
      return {
        PAY_BOX: 'PayBox',
        STORE_SELLER: 'StoreSeller',
        APP: 'App',
        WEBSITE: 'Website',
        SELF_SERVICE: 'SelfService',
        BAR_CONSUMPTION: 'BarConsumption',
        INVOICE: 'Invoice',
      }
    },
    saleOriginLabel() {
      return {
        PayBox: this.$t('Caixa'),
        StoreSeller: this.$t('Vendedor'),
        App: this.$t('Aplicativo'),
        AppB2b: this.$t('Aplicativo B2B'),
        Website: this.$t('Site'),
        SelfService: this.$t('Auto atendimento'),
        Invoice: this.$t('Nota fiscal'),
        BarConsumption: this.$t('Bar'),
        EchopeJa: this.$t('echope já'),
        SmartPos: this.$t('Smart POS')
      }
    },
    echopeClassificationLabel() {
      return {
        [echopeClassificationEnum.E1]: this.$t('Normal (E1)'),
        [echopeClassificationEnum.E2]: this.$t('Eventos (E2)'),
        [echopeClassificationEnum.E3]: this.$t('Outros (E3)'),
        [echopeClassificationEnum.E4]: this.$t('Comercial (E4)'),
        [echopeClassificationEnum.E5]: this.$t('Comercial Loja (E5)'),
      }
    },
  },

  methods: {
    saleOriginOptions() {
      return [
        { value: 'PayBox', label: this.$t('Caixa') },
        { value: 'StoreSeller', label: this.$t('Vendedor') },
        { value: 'App', label: this.$t('App') },
        { value: 'Website', label: this.$t('Site') },
        { value: 'SelfService', label: this.$t('Auto atendimento') },
        { value: 'BarConsumption', label: this.$t('Bar') },
        { value: 'EchopeJa', label: this.$t('echope já') },
      ]
    },
    saleOriginToOrderOptions() {
      return [
        { value: 'PayBox', label: this.$t('PDV') },
        { value: 'SmartPos', label: this.$t('Smart POS') },
        { value: 'StoreSeller', label: this.$t('Vendedor') },
        { value: 'App', label: this.$t('App') },
        { value: 'Website', label: this.$t('Site') },
        { value: 'SelfService', label: this.$t('Auto atendimento') },
        { value: 'BarConsumption', label: this.$t('Bar') },
        { value: 'EchopeJa', label: 'echope já'}
      ]
    },
    echopeClassificationOptions() {
      return [
        { value: echopeClassificationEnum.E1, label: this.$t('Normal (E1)') },
        { value: echopeClassificationEnum.E2, label: this.$t('Eventos (E2)') },
        { value: echopeClassificationEnum.E3, label: this.$t('Outros (E3)') },
        { value: echopeClassificationEnum.E4, label: this.$t('Comercial (E4)') },
        { value: echopeClassificationEnum.E5, label: this.$t('Comercial Loja (E5)') },
      ]
    },

    mxValidatePrintForOnlineSale(sale) {
      const result = { valid: true, message: '' }

      const { PAY_ONLINE } = onlinePaymentModelEnum
      const { COMPLETED } = statusTypes.computed.saleStatusEnum()
      if (sale?.onlinePayment?.paymentModel === PAY_ONLINE && sale.status !== COMPLETED) {
        result.message = this.$t('SALE.UI.ONLINE_PAYMENT_PRINT_BEFORE_COMPLETE')
        result.valid = false
      }

      return result
    },
    coldOptionOptions() {
      return [
        { value: coldOptionEnum.COLD_ON_ICE, label: this.$t('Embalado no gelo') },
        { value: coldOptionEnum.COLD, label: this.$t('Gelado') },
        { value: coldOptionEnum.NATURAL, label: this.$t('Natural') },
      ]
    },
    pickupPointOptions() {
      return [
        { value: pickupPointEnum.COUNTER, label: this.$t('Balcão') },
        { value: pickupPointEnum.DRIVE_THRU, label: this.$t('Drive Thru') },
      ]
    },
  },
}

export default saleDomain
